import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import store from './Redux/store'
import environment from 'environments/environment'

/**
 * @file Index.jsx
 * @fileoverview React starting main file, it call App.jsx for manage all other react function and also call Provider for manage redux storage
 * @author Anuragh KP <kpanuragh@gmail.com>
 *
 */
document.title = environment.companyTitle || 'Payment Portal'

const metaTitle = document.querySelector('meta[name="Payment Portal Web app"]')
if (metaTitle) {
  metaTitle.setAttribute('name', environment.metaTitle || 'App Web Description')
}

const favicon = document.querySelector("link[rel~='icon']")
if (favicon && environment.favicon) {
  favicon.href = environment.favicon.replace(
    '%PUBLIC_URL%',
    process.env.PUBLIC_URL || '',
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
